import { useTranslation } from "react-i18next"

type Translations = typeof defaultTranslations

const defaultTranslations = {
  addCardButtonLabel: "Add a new card",
  addTaskButtonLabel: "Add as task",
  addTodoButtonLabel: "Add as todo",
  addTaskButtonTip: "Adding a task will add a new task which will be visible in gantt chart and task list views",
  addTodoButtonTip:
    "Adding a todo will add a new todo which will be visible only in todo list view and it will not affect gantt chart",
  cardTitlePlaceholder: "Enter title here",
  inputQueueLabel: "Input queue",
  backlogLabel: "Backlog",
  notStartedLabel: "Not started",
  planningLabel: "Planning",
  implementationLabel: "Implementation",
  reviewLabel: "Review",
  testingLabel: "Testing",
  deploymentLabel: "Deployment",
  completedLabel: "Completed",
  openKanbanBtnLabel: "Open task kanban",
  maximizeBtnTip: "Open task in full screen",
  headerText: "Board column's visibility",
  buttonLabel: "Choose columns",
  buttonTip: "Open board's column chooser menu",
  moveToLeft: "Move to left",
  moveToRight: "Move to right",
  moveToColumn: "Move to column",
  cardWillMoveTo: "Card will move to",
}

export const useTranslations = (): Translations => {
  const { t } = useTranslation("translation")
  const { t: tProject } = useTranslation("project")

  return {
    addCardButtonLabel: t("boardColumn.addCardButtonLabel", {
      defaultValue: defaultTranslations.addCardButtonLabel,
    }),
    addTaskButtonLabel: t("boardColumn.addTaskButtonLabel", {
      defaultValue: defaultTranslations.addTaskButtonLabel,
    }),
    addTodoButtonLabel: t("boardColumn.addTodoButtonLabel", {
      defaultValue: defaultTranslations.addTodoButtonLabel,
    }),
    addTaskButtonTip: t("boardColumn.addTaskButtonTip", {
      defaultValue: defaultTranslations.addTaskButtonTip,
    }),
    addTodoButtonTip: t("boardColumn.addTodoButtonTip", {
      defaultValue: defaultTranslations.addTodoButtonTip,
    }),
    cardTitlePlaceholder: t("boardColumn.cardTitlePlaceholder", {
      defaultValue: defaultTranslations.cardTitlePlaceholder,
    }),
    inputQueueLabel: t("boardColumn.inputQueueLabel", {
      defaultValue: defaultTranslations.inputQueueLabel,
    }),
    backlogLabel: t("boardColumn.backlogLabel", {
      defaultValue: defaultTranslations.backlogLabel,
    }),
    notStartedLabel: tProject("projectStatusMenu.notStarted", {
      defaultValue: defaultTranslations.notStartedLabel,
    }),
    planningLabel: t("boardColumn.planningLabel", {
      defaultValue: defaultTranslations.planningLabel,
    }),
    implementationLabel: t("boardColumn.implementationLabel", {
      defaultValue: defaultTranslations.implementationLabel,
    }),
    reviewLabel: t("boardColumn.reviewLabel", {
      defaultValue: defaultTranslations.reviewLabel,
    }),
    testingLabel: t("boardColumn.testingLabel", {
      defaultValue: defaultTranslations.testingLabel,
    }),
    deploymentLabel: t("boardColumn.deploymentLabel", {
      defaultValue: defaultTranslations.deploymentLabel,
    }),
    completedLabel: tProject("projectStatusMenu.completed", {
      defaultValue: defaultTranslations.completedLabel,
    }),
    openKanbanBtnLabel: t("boardCard.openKanbanBtnLabel", {
      defaultValue: defaultTranslations.openKanbanBtnLabel,
    }),
    maximizeBtnTip: t("boardCard.maximizeBtnTip", {
      defaultValue: defaultTranslations.maximizeBtnTip,
    }),
    headerText: t("boardColumnChooser.headerText", {
      defaultValue: defaultTranslations.headerText,
    }),
    buttonLabel: t("boardColumnChooser.buttonLabel", {
      defaultValue: defaultTranslations.buttonLabel,
    }),
    buttonTip: t("boardColumnChooser.buttonTip", {
      defaultValue: defaultTranslations.buttonTip,
    }),
    moveToLeft: t("moveToLeft", { defaultValue: defaultTranslations.moveToLeft }),
    moveToRight: t("moveToRight", { defaultValue: defaultTranslations.moveToRight }),
    moveToColumn: t("moveToColumn", { defaultValue: defaultTranslations.moveToColumn }),
    cardWillMoveTo: t("cardWillMoveTo", { defaultValue: defaultTranslations.cardWillMoveTo }),
  }
}
